import { LitElement, html, css } from 'lit'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import '../hero'
import './cat'
import './faq'
import './itinerary'
import './recent'
import './reviews'
import '../../../../bui/elements/flex'

customElements.define('k-trip', class extends LitElement{

    static styles = css`
        :host {
            display: block;
            position:relative;
        }

        k-hero *:not(:is(div,b-grid,b-flex)) {
            font-family: var(--font-header);
            background: rgb(from var(--color, #fff) r g b / .8);
            line-height: 1em;
            display: inline-block;
            padding: .5rem .65rem;
            text-transform: uppercase;
            clip-path: polygon(.1em 0, 100% 0, 99% 100%, 0 100%);
        }

        k-trip-category {
            color: white;
        }

        b-tabs {
            --contentPadding: 0;
            --overflow: visible;
        }

        b-tabs > * {
            margin-top: 2em;
        }

        b-tabs > div > :first-child {
            margin-top: 0;
        }
    `

    constructor(){
        super()
        this.data = window.tripData || {}
    }

    updated(){
        this.classList.toggle('hero', this.data.hero?.large)
        this.style.setProperty('--hero-img-pos', this.data.hero_pos)
    }

    render(){return html`

        <k-hero .img=${this.data.hero.large}>
            <h1>${this.data.title}</h1>

            <b-flex left>
                <k-trip-category .data=${this.data}></k-trip-category>
                ${this.data.days?html`
                <b-text class="days">${this.data.days} days</b-text>
                `:''}
                ${this.data.elevation?html`
                <b-text class="elevation">${this.data.elevation?.toLocaleString()} meters</b-text>
                `:''}
            </b-flex>
        </k-hero>

        <b-tabs class="tabs" _key="trips" tab-bar="k-trips-tab-bar">

            <div class="info" title="Overview">
                ${unsafeHTML(this.data.content)}

                <k-trip-reviews></k-trip-reviews>

                <k-trip-recent-posts></k-trip-recent-posts>
            </div>

            ${this.data.faq?html`<k-faq title="FAQ" .data=${this.data.faq}></k-faq>`:''}
            ${this.data.itinerary?html`<k-itinerary title="Itineary" .data=${this.data.itinerary}></k-itinerary>`:''}

            <div title="Cost">
                <h3>Include</h3>
                <ul>
                    ${this.data.costs?.include?.map(s=>html`<li>${s}</li>`)}
                </ul>

                <h3>Exclude</h3>
                <ul>
                    ${this.data.costs?.exclude?.map(s=>html`<li>${s}</li>`)}
                </ul>
            </div>

        </b-tabs>
        
        
    `}

})

export default customElements.get('k-trip')